import React from "react";

type Props = {
  children: React.ReactNode;
};

const ContentLayout = ({ children }: Props) => {
  return (
    <div className="flex w-full justify-center">
      <div className="mb-12 mt-9 w-full max-w-[1440px] px-6 md:px-[100px]">{children}</div>
    </div>
  );
};

export default ContentLayout;
